import Vue from 'vue'
import App from './App'
import { Select, Option, Popover, Dropdown } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import router from './router'

Vue.config.productionTip = false

locale.use(lang)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(Popover.name, Popover)
Vue.component(Dropdown.name, Dropdown)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js